export enum PolicyResultStatus {
    Qualified = 'qualified',
    Unqualified = 'unqualified',
}
